import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as api from '../../../api';
import ListItem from '../ListItem/ListItem';
import './School.css';
import { ITEM_TYPE } from '../../../constants';
import * as textHelper from '../../../utils/TextHelper';

// todo - show some 'fetching' state?
// todo - move intro texts to json file

const intro0 = 'Materiály z databáze TOTO100LETÍ mohou zpestřit i výuku dějepisu nebo občanské výchovy. Využití pramenů a dobových materiálů přímo v hodině zvyšuje efektivitu výuky a do diskuze se zapojují i žáci, kteří jinak v hodinách dějepisu nebývají příliš aktivní.<br />Níže najdete několik námětů na vyučovací hodiny sestavené z videí, článků a dalších materiálů, které jsou spojeny do tematických celků. Principem námětů je doplnění vybraných materiálů o otázky, které poslouží jako podnět pro debatu ve třídě a u žáků prohloubí zájem o některé problémy českých soudobých dějin. Jednotlivá témata jsou pak spojena i didaktickými cíli, k jejichž naplnění by analýza materiálů měla vést.';
const intro1 = 'Přejeme hodně zvídavých a přemýšlivých studentů…';

class School extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetching: true,
      list: [],
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    api.getSchoolList().then((data) => {
      this.setState({
        fetching: false,
        list: data,
      });
    }).catch(() => {
      // todo - solve error state
    });
  }

  render() {
    const items = this.state.list.map(item => (
      <ListItem
        key={item.id}
        grid={this.props.grid}
        itemData={[
          item.id,
          {
            id: item.id,
            type: ITEM_TYPE.SCHOOL_SHEET,
            title: item.title,
          },
        ]}
      />
    ));

    return (
      <div>
        <div id="school-head">TOTO100LETÍ VE ŠKOLE</div>
        <div id="school-desc">
          <p dangerouslySetInnerHTML={{ __html: textHelper.formatText(intro0) }} />
          <p dangerouslySetInnerHTML={{ __html: textHelper.formatText(intro1) }} />
        </div>
        <div>{items}</div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  grid: state.resize.grid,
});

export default connect(mapStateToProps)(School);



// WEBPACK FOOTER //
// ./src/components/App/School/School.js